(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    function fitTitle(el) {
      if (!el) return;
      el.style.fontSize = '';
      var minSize = 11;
      var size = parseFloat(window.getComputedStyle(el).fontSize);
      var guard = 0;
      while (el.scrollWidth > el.clientWidth + 1 && size > minSize && guard < 60) {
        size -= 0.5;
        el.style.fontSize = size + 'px';
        guard++;
      }
    }
    function fitAll() {
      document.querySelectorAll('.product__title h1, .product__title h2, .product__title--mobile h1').forEach(fitTitle);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fitAll);
    } else {
      fitAll();
    }
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(fitAll, 120);
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
